"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
require("cn-next/es/menu/style");
var _menu = _interopRequireDefault(require("cn-next/es/menu"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactDom = require("react-dom");
var _excluded = ["prefix", "useVirtual", "className", "style", "children"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var CascaderMenu = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(CascaderMenu, _Component);
  function CascaderMenu() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.saveMenuRef = function (ref) {
      _this.menuEl = ref;
    };
    _this.saveVirtualRef = function (ref) {
      _this.virtualEl = ref;
    };
    return _this;
  }
  var _proto = CascaderMenu.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.scrollToSelectedItem();
  };
  _proto.scrollToSelectedItem = function scrollToSelectedItem() {
    var _this$props = this.props,
      prefix = _this$props.prefix,
      useVirtual = _this$props.useVirtual,
      children = _this$props.children;
    if (!children || children.length === 0) {
      return;
    }
    var selectedIndex = children.findIndex(function (item) {
      return !!item.props.checked || !!item.props.selected || !!item.props.expanded;
    });
    if (selectedIndex === -1) {
      return;
    }
    if (useVirtual) {
      var instance = this.virtualEl.getInstance();
      setTimeout(function () {
        return instance.scrollTo(selectedIndex);
      }, 0);
    } else {
      var itemSelector = "." + prefix + "menu-item";
      var menu = (0, _reactDom.findDOMNode)(this.menuEl);
      var targetItem = menu.querySelectorAll(itemSelector)[selectedIndex];
      if (targetItem) {
        menu.scrollTop = targetItem.offsetTop - Math.floor((menu.clientHeight / targetItem.clientHeight - 1) / 2) * targetItem.clientHeight;
      }
    }
  };
  _proto.renderMenu = function renderMenu(items, ref, props) {
    var _this2 = this;
    return /*#__PURE__*/_react["default"].createElement(_menu["default"], (0, _extends2["default"])({
      ref: ref,
      role: "listbox"
    }, props), items.map(function (node) {
      if ( /*#__PURE__*/_react["default"].isValidElement(node) && node.type.menuChildType === 'item') {
        return /*#__PURE__*/_react["default"].cloneElement(node, {
          menu: _this2
        });
      }
      return node;
    }));
  };
  _proto.render = function render() {
    var _this$props2 = this.props,
      prefix = _this$props2.prefix,
      useVirtual = _this$props2.useVirtual,
      className = _this$props2.className,
      style = _this$props2.style,
      children = _this$props2.children,
      others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props2, _excluded);
    var menuProps = (0, _extends2["default"])({
      labelToggleChecked: false,
      className: prefix + "cascader-menu"
    }, others);
    return /*#__PURE__*/_react["default"].createElement("div", {
      ref: this.saveMenuRef,
      className: prefix + "cascader-menu-wrapper " + (className ? className : ''),
      style: style
    }, this.renderMenu(children, undefined, menuProps));
  };
  return CascaderMenu;
}(_react.Component);
exports["default"] = CascaderMenu;
CascaderMenu.propTypes = {
  prefix: _propTypes["default"].string,
  className: _propTypes["default"].string,
  useVirtual: _propTypes["default"].bool,
  children: _propTypes["default"].node
};
module.exports = exports.default;
module.exports.default = exports.default;